import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=53a0dcc0&lang=html&"
import script from "./feedback.vue?vue&type=script&lang=ts&"
export * from "./feedback.vue?vue&type=script&lang=ts&"
import style0 from "./feedback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports